import {Typography} from "@material-ui/core";
import React, {FC} from "react";
import {useSelector} from "react-redux";
import {useTranslate} from "@tolgee/react";
import {selectUser} from "store/auth/selectors";
import {getOrderStatusMap} from "tools/order/getOrderStatus";
import {ExpandedOrder} from "ts/api/order";
import {useOrderRefunds} from "store/refund/refund.store";

type PaymentStatusLabelProps = {
  order: ExpandedOrder;
  label?: string;
  companyId?: string;
};

const PaymentStatusLabel: FC<PaymentStatusLabelProps> = ({
  order,
  label: propsLabel,
  companyId,
}) => {
  const {t} = useTranslate();
  const user = useSelector(selectUser);
  const {refunds, isLoading} = useOrderRefunds(order.id);
  if (isLoading) {
    return null;
  }

  const orderStatusMap = getOrderStatusMap(order, refunds, user, companyId);
  const translatedLabel = orderStatusMap.translationKey
    ? t({
        key: orderStatusMap.translationKey,
        defaultValue: orderStatusMap.label,
      })
    : orderStatusMap.label;
  const label = propsLabel || translatedLabel;
  return (
    <Typography
      variant="body2"
      style={{color: orderStatusMap.color, textTransform: "capitalize"}}
    >
      {label}
    </Typography>
  );
};

export default PaymentStatusLabel;
